export default "__VITE_ASSET__B8TGfxjQ__"